/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
import PreviewConfig from '../../previewconfig/previewconfig'
import Space from 'material/space/space'
import { ReactComponent as ArrowSync } from 'assets/icons/arrow-sync.svg'
// styles
import injectSheet from 'react-jss'
import styles from './realtimecapability_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : REAL-TIME CAPABILITY ~~~~~~~~~~ ========== */
const RealTimeCapability = injectSheet(styles)((props) => {
  
  const { useRealTimeIndicator, onChange } = props

  return (
    <SectionGroupV2 klass={`realtimecapability ${props.classes.realtimecapability}`} title={'Real-Time Indicators'} description={`Select whether users can instantly see who's online and interacting with comments.`}>
      <ConfigToggle 
        title={'Enable real-time'}
        description={`See who's online, actively typing, new comments, and more.`}
        checked={useRealTimeIndicator}
        onChange={() => onChange('useRealTimeIndicator', !useRealTimeIndicator)}
      />
      <PreviewConfig disabled={!useRealTimeIndicator}>
        <Space alignItems={'center'} justifyContent={'center'} klass={'realtimepreview'}>
          <span className='circles'>
            <span className='circle'></span>
            <span className='circle'></span>
            <span className='circle'></span>
          </span>
          <span>16 typing</span>
          <span className={'divider'}></span>
          <ArrowSync />
          <span>View 27 new comments</span>
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default RealTimeCapability;